var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModelSummaryOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0H2.5C1.39543 0 0.5 0.89543 0.5 2V18C0.5 19.1046 1.39543 20 2.5 20H12C13.1046 20 14 19.1046 14 18V2C14 0.89543 13.1046 0 12 0Z",
    fill: "#272D55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H2.5C1.67157 0.5 1 1.17157 1 2V18C1 18.8284 1.67157 19.5 2.5 19.5H12C12.8284 19.5 13.5 18.8284 13.5 18V2C13.5 1.17157 12.8284 0.5 12 0.5Z",
    stroke: "#272D55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4H12.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7H12.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10H12.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13H12.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16H12.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelSummaryOperationIcon);
export default __webpack_public_path__ + "static/media/ModelSummaryOperationIcon.c8088ccf07a6192738f6840d1d0dde92.svg";
export { ForwardRef as ReactComponent };